import { Box, Image } from 'native-base';
import { useMemo } from 'react';

import { ActivityCoverStyleMap } from '~/pages/Authenticated/v2/ActivityView/components/ActivityCover/constants';
import {
  ActivityCoverProps,
  CoverStyleAtributes,
} from '~/pages/Authenticated/v2/ActivityView/components/ActivityCover/type';
import { colors } from '~/theme/colors';

export const ActivityCover = (props: ActivityCoverProps) => {
  const { coverImage, activityType } = props;

  const style = useMemo(() => {
    if (!activityType) return { backgroundColor: colors.red[400] };
    return ActivityCoverStyleMap.get(activityType) as CoverStyleAtributes;
  }, [activityType]);

  return coverImage ? (
    <Box
      w="full"
      h={{ base: '240', lg: '444px' }}
      position="relative"
      overflow="hidden"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box position="absolute" w="full" h="full" overflow="hidden">
        <Image
          alt={'activity cover background'}
          source={{ uri: coverImage }}
          w="full"
          h="full"
          opacity={1}
          resizeMode="cover"
          blurRadius={50}
        />
      </Box>
      <Image
        alt={'activity cover image'}
        source={{ uri: coverImage }}
        w={{
          base: '100%',
          lg: '665px',
        }}
        h={{ base: '240', lg: '444px' }}
        resizeMode="contain"
        zIndex={1}
      />
    </Box>
  ) : (
    <Box bg={style.backgroundColor} w={'full'} h={{ base: '20' }} mb={-10} />
  );
};

export default ActivityCover;
